/**
 * LE TRACÉ D'UN ÉLÈVE ET LE TRACÉ ATTENDU, SUR LE MÊME REPÈRE — la liste
 * d'affichage que montre la correction d'un exercice répondu par un tracé
 * (nature `trace`, analyse 05, L-2 et L-3).
 *
 * ─── Pourquoi ici ───────────────────────────────────────────────────────────
 *
 * Trois écrans montrent ces deux tracés : la correction qu'on vient de
 * recevoir et l'historique de l'élève (application), et « Travaux et
 * corrections » de la console du tuteur. La composition vivait dans le
 * composant de l'application ; la console l'aurait réécrite. Une règle de
 * superposition écrite deux fois, c'est un tuteur qui discute d'un dessin que
 * l'élève n'a jamais vu. Elle est donc ici, PURE, et les deux la peignent —
 * `<DessinTons>` dans l'application, `listeVersSvg` dans la console.
 *
 * ─── La règle ───────────────────────────────────────────────────────────────
 *
 * Le tracé attendu SOUS celui de l'élève, en pointillé, au ton `attendu` : un
 * tracé juste le recouvre — l'élève voit le sien, plein — ; un tracé à revoir
 * le laisse paraître à côté. Le calque de l'énoncé reste dessous tout.
 *
 * `enonce` : la figure sur laquelle le tracé a été fait, normalisée ; `null`
 * quand l'exercice n'en a pas — ou quand l'essai ne la garde pas (un essai
 * d'avant la tranche T2) : le repère du tracé suffit alors.
 */
import { resoudreConstruction, versFigureV2, } from './construction.js';
import { decrireConstruction } from './decrire-v2.js';
import { dessinerPlan, } from './figure-v2.js';
export function superposerLesTraces(eleve, attendu, enonce) {
    const resolue = resoudreConstruction(eleve, enonce);
    const figure = versFigureV2(resolue, { calque: true });
    const reference = attendu === null ? null : resoudreConstruction(attendu, enonce);
    const dessous = reference === null
        ? []
        : versFigureV2(reference, { calque: false }).objets.map((o) => ({
            ...o,
            id: `attendu:${o.id ?? ''}`,
            ton: 'attendu',
            ...(o.type === 'droite' || o.type === 'segment' ? { style: 'pointille' } : {}),
        }));
    const phrases = [`Ton tracé. ${decrireConstruction(eleve, resolue).description}`];
    if (attendu !== null && reference !== null) {
        phrases.push(`Le tracé attendu. ${decrireConstruction(attendu, reference).description}`);
    }
    return {
        liste: dessinerPlan({
            ...figure,
            objets: [
                ...figure.objets.filter((o) => o.ton !== 'eleve'),
                ...dessous,
                ...figure.objets.filter((o) => o.ton === 'eleve'),
            ],
        }, { cadre: 'repere' }),
        description: phrases.join(' '),
    };
}
//# sourceMappingURL=traces-superposes.js.map